import React from "react";
import "./projects.css";
import IMGDreadManor from "../../assets/DreadManor.webp";

const projects = [
  {
    title: "Dread Manor",
    role: "Producer · Director · Lead Unity Developer",
    image: IMGDreadManor,
    description:
      "Solo-developed and published a horror escape game on Google Play — 4.9★ rating and 1,500+ downloads. Now producing its full redevelopment for a Steam release.",
    tags: ["Unity", "Google Play", "Steam (WIP)"],
    link: "https://www.notion.so/Dread-Manor-27334068b7b280ca8954eb57c4ca4ac7",
    badge: "Shipped · In Redevelopment",
  },
  {
    title: "Dread Protocol",
    role: "Game Producer · Director",
    monogram: "DP",
    description:
      "Producing an original co-op horror title with an internationally distributed team of up to 10 — owning production, multiplayer implementation (Photon Fusion), and Steam release planning.",
    tags: ["Photon Fusion", "Multiplayer", "Team of 10", "Steam"],
    badge: "In Production",
  },
  {
    title: "Educational & Enterprise Games",
    role: "Producer · Lead Developer",
    monogram: "E&E",
    description:
      "Designed and delivered multiple educational, arcade, and enterprise learning games for commercial clients across Unity, MonoGame, and WinForms — from concept workshops to launch.",
    tags: ["Unity", "MonoGame", "WinForms", "Client Work"],
    badge: "6 Client Projects",
  },
];

const Projects = () => {
  return (
    <section id="projects">
      <h5>Selected Work</h5>
      <h2>Featured Projects</h2>
      <div className="container projects__container">
        {projects.map((p) => (
          <article className="project__card" key={p.title}>
            <div className="project__media">
              {p.image ? (
                <img src={p.image} alt={p.title} loading="lazy" />
              ) : (
                <span className="project__monogram">{p.monogram}</span>
              )}
              {p.badge && <span className="project__badge">{p.badge}</span>}
            </div>
            <div className="project__body">
              <h3 className="project__title">{p.title}</h3>
              <p className="project__role">{p.role}</p>
              <p className="project__desc">{p.description}</p>
              <ul className="project__tags">
                {p.tags.map((t) => (
                  <li key={t}>{t}</li>
                ))}
              </ul>
              {p.link && (
                <a
                  className="btn btn-primary project__link"
                  href={p.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Case Study
                </a>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Projects;
